import { Accordion, Col, Container, Row } from "react-bootstrap"; 

import calender from "../../../Assets/images/profile-managment/calender.svg"
import clock from "../../../Assets/images/profile-managment/clock.svg"
import { formatDate, formatTime } from "../../../Utils/Common";
const SampleCollectionAppointmentAccordion= ({type, sampleRequestDetails,pickupDaysAvailableWRTSampleCount})=>{
return(
    // <Accordion defaultActiveKey="1" flush>
    <Accordion.Item eventKey="5">
        <Accordion.Header><b>Sample Collection Appointment</b></Accordion.Header>
        <Accordion.Body>
            <p><b>This request requires a {sampleRequestDetails?.request?.sample_collect_duration || '-'} min appointment block.</b></p>
            <div className="flex-sec justify-content-start my-3">
                <div className="el-flex-area mb-3 mb-lg-0">
                    {/* <div className="location-icon">
                        <img src={calender} alt="" />
                    </div> */}
                    {type !== 'admin' && (
    <>
        <div className="el-content-detail">
            <p className="el-request-detail-profile-title">
                Notified Requestor (Timestamp) on:
            </p>
            <h4 className="el-request-detail-profile-name">
                {
                    (() => {
                        const pickupDate = sampleRequestDetails?.request?.pickup_date_notify;
                        const pickupTime = sampleRequestDetails?.request?.pickup_time_notify;

                        if (pickupDate) {
                            const formattedDate = formatDate(pickupDate);
                            const formattedTime = pickupTime ? formatTime(pickupTime) : '-';
                            return (
                                <div className="d-flex">
                                    <div>{formattedDate}<span>,</span></div>
                                    <div className="ms-2">{formattedTime}</div>
                                </div>
                            );
                        } else {
                            return <span>-</span>; // Display a placeholder or a default value if no valid date
                        }
                    })()
                }
            </h4>
        </div>
    </>
)}

                    <div className="el-content-detail">
                        <p className="el-request-detail-profile-title">
                            Selected Date
                        </p>
                        <h4 className="el-request-detail-profile-name">

                            {formatDate(sampleRequestDetails?.request?.sample_pickup_date)}
                            {/* {sampleRequestDetails?.request?.sample_pickup_date
                                ? new Date(sampleRequestDetails.request.sample_pickup_date).toLocaleDateString("en-US", {
                                    year: "numeric",
                                    month: "long",
                                    day: "numeric"
                                })
                                : '-'} */}
                        </h4>

                    </div>
                </div>
                <div className="el-flex-area mb-3 mb-lg-0">
                    <div className="location-icon">
                        <img src={clock} alt="" className="me-3" />
                    </div>
                    <div className="el-content-detail">
                        <p className="el-request-detail-profile-title">
                           { type==='admin' ? 'Selected Pickup Time' : 'Appointment Time' } 
                        </p>
                        <h4 className="el-request-detail-profile-name">
                            {formatTime(sampleRequestDetails?.request?.sample_pickup_time)}
                        </h4>
                    </div>

                </div>
            </div>
                {/* <p>1 to 5 samples | 3 Business days <br /> 6 to 9 samples | 6 Business days <br /> 10+ samples | 11 Business days</p> */}

                {type!=='admin' && (
                    <>
                        <div className="my-2">
                            <div>
                                    {pickupDaysAvailableWRTSampleCount.length > 0 ? (
                                        <span>
                                            {pickupDaysAvailableWRTSampleCount.map((pickupDay) => (
                                                <p key={pickupDay.id}>
                                                    {pickupDay.max_sample
                                                        ? `${pickupDay.min_sample} to ${pickupDay.max_sample} samples | ${pickupDay.day} Business days`
                                                        : `${pickupDay.min_sample}+ samples | ${pickupDay.day} Business days`}
                                                </p>
                                            ))}
                                        </span>
                                    ) : (
                                        <p>Loading data...</p>
                                    )}
                                </div>
                        <p>
                        If requests are submitted after 12pm ET, processing begins the next business day.
                        </p>
                        </div>
                    </>
                )}
        </Accordion.Body>
    </Accordion.Item>
// </Accordion>
);
}

export default SampleCollectionAppointmentAccordion